import { motion } from 'framer-motion';

import CloseShape from '@/components/common/svg/shapes/CloseShape';
import UIConfig from '@/UIConfig.ts';
import FireReactionShape from '@/components/common/svg/shapes/FireReactionShape.tsx';
import { HeartShape } from '@/components/common/svg/shapes/HeartShape.tsx';
import { useJoyrideTourStore } from '@/store/useJoyrideTourStore.ts';

interface IProps {
  handleLike: () => void;
  handlePass: () => void;
  handleReaction: () => void;
}

const buttonStyle = {
  width: '29%',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2px',
  outline: 'none',
  borderRadius: UIConfig.Card.LikeButton.borderRadius,
  height: UIConfig.Card.LikeButton.height
};

const ActionButtons = ({ handleLike, handlePass, handleReaction }: IProps) => {
  const { stopTour } = useJoyrideTourStore();

  return (
    <div
      style={{
        position: 'relative',
        height: '65px',
        width: '100%',
        background: UIConfig.Card.Content.background,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        borderBottomLeftRadius: UIConfig.Card.Content.borderRadius,
        borderBottomRightRadius: UIConfig.Card.Content.borderRadius,
        borderTop: 'none',
        marginTop: '8px',
        marginBottom: '2px'
      }}
      className="cardControlButtons"
    >
      <motion.div
        style={{
          marginLeft: '8px',
          ...buttonStyle,
          background: '#595959',
          color: '#fff'
        }}
        onClick={handlePass}
        whileTap={{ scale: 0.9 }}
      >
        <CloseShape width={35} height={35} strokeWidth={1} fillColor="#fff" />
      </motion.div>

      <motion.div
        className="reaction-button"
        style={{
          ...buttonStyle,
          background:
            'linear-gradient(to top, #FFB433 0%, #FDCB40 80%, #FFE066 100%)',
          color: UIConfig.Card.LikeButton.color
        }}
        onClick={() => {
          stopTour();
          handleReaction();
        }}
        whileTap={{ scale: 0.9 }}
      >
        <FireReactionShape fillColor="#ffffff" />
      </motion.div>

      <motion.div
        style={{
          marginRight: '8px',
          ...buttonStyle,
          background: '#ffffff',
          color: '#000000'
        }}
        onClick={handleLike}
        whileTap={{ scale: 0.9 }}
      >
        <HeartShape />
      </motion.div>
    </div>
  );
};

export default ActionButtons;